import React from "react";
import { DraggableProvided } from "react-beautiful-dnd";

import { Stack, Typography } from "@mui/material";
import { NavigateLink } from "components/Navigate-link/NavigateLink";
import { useAllowDealTabOpenSelector } from "store";
import { DealStageItem } from "store/types";

interface Props extends DealStageItem {
  draggableProvided: DraggableProvided;
  stageId: number;
}

export const PipelineCard: React.FC<Props> = ({ id, title, draggableProvided, stageId }) => {
  const allowNewTab = useAllowDealTabOpenSelector();
  return (
    <NavigateLink allowNewTab={allowNewTab} route="deal" params={{ deal_id: String(id) }}>
      <Stack
        sx={{
          bgcolor: "#f6f8fc",
          borderRadius: "8px",
          p: "8px",
          gap: "12px",
          justifyContent: "center",
          cursor: "pointer",
          ...draggableProvided.draggableProps.style
        }}
        {...draggableProvided.dragHandleProps}
        {...draggableProvided.draggableProps}
        ref={draggableProvided.innerRef}
      >
        <Stack
          sx={{ gap: "2px", cursor: "pointer !important" }}
          data-rbd-drag-handle-context-id={draggableProvided.dragHandleProps?.["data-rbd-drag-handle-context-id"]}
          data-rbd-drag-handle-draggable-id={`stage-${stageId}`}
        >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24px",
              color: "#071f35",
              whiteSpace: "normal",
              wordBreak: "break-word"
            }}
          >
            {title}
          </Typography>
        </Stack>
      </Stack>
    </NavigateLink>
  );
};
